export const ZavoodskayaData = [
    {
        title: "дом №2а",
        year: '1973',
        floor: "2",
        apartment: "22",
        quantityLC: "22",
        livingArea: "991,2",
        notLivinigArea: "нет",
        commonProperty: "83",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'zavodskaya/sofrino_zavodskaya_2a_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №5",
        year: '1986',
        floor: "5",
        apartment: "53",
        quantityLC: "56",
        livingArea: "2268,2",
        notLivinigArea: "нет",
        commonProperty: "172,2",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, электроснабжение",
        technicalSupport: "общедомовой прибор учета ХВС",
        contractURL: 'zavodskaya/sofrino_zavodskaya_5_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }

]